export default function TortaNull() {
    return <div style={{ gridAutoRows: '18rem' }} className='center'>
        <div style={{ gridAutoRows: '12rem' }} className='no-data bg-black center'>
            <b>SIN REGISTROS</b>
        </div>
    </div>
}